// Em producao o caminho e relativo de proposito: o app responde por dois
// dominios (lauanarezendeadv.com.br e brunoelauana.com.br) e os dois servem
// /api pelo mesmo nginx. URL absoluta quebraria por CORS no dominio do casamento.
export const EH_LOCAL = ['localhost', '127.0.0.1'].includes(window.location.hostname);

export const API_URL = EH_LOCAL ? 'https://lauanarezendeadv.com.br/api' : '/api';
// Para apontar o front local numa API local: 'http://localhost:8081/api'
